export default __webpack_public_path__ + "static/media/OldCoachHouse.183cc968.jpg";